export interface Review {
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const reviews: Review[] = [
  {
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20avatar%2C%20warm%20minimal%20style%2C%20clean%20cream%20background%2C%20friendly%20smile%2C%20natural%20lighting%2C%20editorial%20photography&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '用了网页版免费91快半年了，真的非常方便。以前处理PDF要下载各种软件，现在打开浏览器就能搞定，省时省力。最赞的是完全免费，强烈推荐！',
    date: '2024-12-18',
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20professional%20portrait%20avatar%2C%20warm%20minimal%20style%2C%20clean%20cream%20background%2C%20gentle%20smile%2C%20natural%20soft%20lighting%2C%20editorial%20photography&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '作为远程办公的自由职业者，网页版免费91的在线工具大大提高了我的工作效率。文档协作、项目管理都很流畅，而且跨设备同步特别实用。',
    date: '2024-12-15',
  },
  {
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20avatar%2C%20warm%20minimal%20style%2C%20clean%20cream%20background%2C%20bright%20smile%2C%20natural%20lighting%2C%20editorial%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '在学习方面帮了我很多，在线课程资源和知识问答功能都很好用。希望以后能有更多编程相关的学习内容和实战项目。',
    date: '2024-12-12',
  },
  {
    name: '赵经理',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20businessman%20portrait%20avatar%2C%20warm%20minimal%20style%2C%20clean%20cream%20background%2C%20confident%20expression%2C%20natural%20lighting%2C%20editorial%20photography&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '团队协作功能真的很强大。我们部门十几个人现在都在用网页版免费91，项目管理效率提升了不少。在线会议也很稳定，画质清晰。',
    date: '2024-12-08',
  },
  {
    name: '陈女士',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20creative%20portrait%20avatar%2C%20warm%20minimal%20style%2C%20clean%20cream%20background%2C%20artistic%20vibe%2C%20natural%20soft%20lighting%2C%20editorial%20photography&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 5,
    content: '作为一个设计小白，网页版免费91的设计工具让我也能做出好看的图。模板丰富，操作简单，配色推荐功能特别贴心。已经推荐给好几个朋友了！',
    date: '2024-12-03',
  },
];